import FaqSection from '../../components/faq/FaqSection';
import FaqStore from '../../stores/FaqStore';
import Message from '../../components/message/Message';
import PropTypes from 'prop-types';
import QuickLink from '../../components/faq/QuickLink';
import React from 'react';
import {connectToStores} from 'epic-alt-utils/index';

/**
 * FAQ View
 */
@connectToStores
class FaqView extends React.Component {
    static propTypes = {
        faqStore: PropTypes.object
    };

    static getStores() {
        return [FaqStore];
    }

    static getPropsFromStores() {
        return {
            faqStore: FaqStore.getState()
        };
    }

    render() {
        const data = this.props.faqStore || null;
        const faqDataImmutable = data.faqData;
        if (!faqDataImmutable) {
            console.log('FAQ Data not yet available');
            return <div />;
        }
        //faq data
        const faqData = faqDataImmutable;
        const quickLinks = faqData.subSection.sectionList.map((item, index) => {
            const sectionTitle = item.sectTitle;
            const titleID = sectionTitle.replace(/ |\(|\)/g, '-').toLowerCase();
            return (
                <QuickLink
                    key={`sect-${sectionTitle}`}
                    title={sectionTitle}
                    hashTag={titleID} />
            );
        });
        const FAQsection = faqData.subSection.sectionList.map((item, index) => {
            const sectionContent = item.faqList;
            const sectionTitle = item.sectTitle;

            return (
                <FaqSection
                    key={`${sectionTitle}`}
                    title={sectionTitle}
                    sectContent={sectionContent} />
            );
        });
        return (
            <div id="faq">
                <div className="container faq">
                    <h1 className="site-block-page-title">
                        {faqData.mainTitle}
                    </h1>
                    <div className="site-block">
                        <div className="col-md-4 col-md-push-8">
                            <div className="quickLink">
                                <h3><Message code="epic.spyjinx.faq.jump" /></h3>
                                <ul>
                                    {quickLinks}
                                </ul>
                            </div>
                        </div>
                        <div className="col-md-8 col-md-pull-4">
                            {FAQsection}
                        </div>
                        <div className="clearfix" />
                    </div>
                </div>
            </div>
        );
    }
}

export default FaqView;
